<template>
  <v-app :class="$formFrameworkOptions.compact ? 'bxp-compact' : ''">

    <!-- Navigation -->
    <bxp-nav />

    <!-- Page Content -->
    <v-content>

      <v-layout class="bxp-main">
        <!-- Sidebar -->
        <bxp-sidebar
          v-if="$formFrameworkOptions.sidebar"
          class="bxp-sidebar"
          :class="darkBackgroundVal ? 'bxp-dark-bg' : ''" 
          :background-image-url="sidebarBackground"
        >
          <template v-slot:primary-text>
            <slot name="sidebar-primary-text">

            </slot>
          </template>
          <template v-slot:secondary-text>
            <slot name="sidebar-secondary-text">

            </slot>
          </template>
          <template v-slot:sub-text>
            <slot name="sidebar-sub-text">

            </slot>
          </template>
        </bxp-sidebar>

        <!-- Main Content -->
        <bxp-content>
          <template v-slot:content>
            <slot name="main-content">

            </slot>
          </template>
        </bxp-content>

      </v-layout>

      <!-- Error Dialog Modal -->
      <bxp-error-dialog />

      <!-- Error Dialog Modal -->
      <bxp-notice-dialog />

      <bxp-back-to-top />

    </v-content>

    

  </v-app>
</template>

<script>
import BxpNav from "./BxpNav";
import BxpSidebar from "./BxpSidebar";
import BxpContent from "./BxpContent";
import BxpErrorDialog from "./BxpErrorDialog";
import BxpNoticeDialog from "./BxpNoticeDialog";
export default {
  name: "app",
  props: [
    'sidebarBackground',
    'darkBackground'
  ],
  components: {
    BxpNav,
    BxpSidebar,
    BxpContent,
    BxpErrorDialog,
    BxpNoticeDialog
  },
  computed: {
    darkBackgroundVal() {
      if (this.darkBackground || this.darkBackground == '') {
        return true
      }
      return false
    }
  }
};
</script>

<style>
img {
  max-width: 100%;
}
/* Typography */
body, h1, p {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
}

h1 {
  font-size: 48px;
  font-weight: 400;
  line-height: 58px !important;
  margin-bottom: 20px;
}
.bxp-compact h1 {
  font-size: 20px;
  font-weight: 300;
  line-height: 30px !important;
  margin-bottom: 8px;
}

.heading-sub-text {
  margin-bottom: 8px !important;
  font-size: 13px;
}

.bxp-heading-extratext {
  font-size: 12px;
  font-style: italic;
  opacity: 0.7;
}

.bxp-page-subheader {
  font-size: 20px;
  margin-bottom: 24px !important;
}

.bxp-mobile-header {
  display: none;
}

strong {
  font-weight: 500;
}

a {
  text-decoration: none;
}

@media (max-width: 1032px) {

  h1 {
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  p,
  .bxp-page-subheader {
    font-size: 12px;
  }

  .bxp-desktop-header {
    display: none !important;
  }
  .bxp-mobile-header {
    display: block !important;
  }

}

/* END Typography */

/* Fontawesome */
.v-icon.fas {
  font-size: 17px !important;
}
.v-icon.fas.fa-check {
  font-size: 19px !important;
}
.v-icon.fas.fa-times {
  font-size: 22px !important;
}

/* Layout */
#app {
  background-color: white !important;
}

.bxp-main {
  min-height: 100vh;
}

.bxp-form {
  width: 100%;
}

.bxp-form-fields {
  margin-top: 28px;
  margin-right: -33px !important;
  margin-bottom: 8px;
  padding-right: 33px;
}

.text-center {
  text-align: center !important;
}

.inline-block {
  display: inline-block !important;
}

/* Sidebar */
.bxp-sidebar.bxp-dark-bg p {
  color: rgba(255,255,255,0.9) !important;
}

/* Elements */
.bxp-checkbox label {
  display: inline !important;
  font-size: 12px;
}

.bxp-small-icon i {
  margin-top: 6px;
  font-size: 18px;
}

.bxp-tooltip-inner {
  font-size: 17px !important;
  margin-right: 4px;
  margin-top: 5px;
}

.v-input__append-inner:hover .bxp-tooltip-inner {
  color: black !important;
}

.bxp-radio-group .inline{
  display: inline-block;
}

/*Vuetify Overrides*/
.theme--light.application {
  background: white;
}

.v-toolbar__content {
  height: 120px;
}
.v-toolbar__content,
.v-toolbar__extension {
  padding: 0 24px;
}

main.v-content {
  padding-top: 100px;
}

.v-text-field .v-label {
  line-height: 28px;
  overflow: visible;
}

.v-text-field .v-input__slot {
  padding: 9px 0;
}

.v-input__prepend-inner .v-input__slot {
  padding: 0;
}

.v-text-field .v-input__prepend-inner {
  padding-right: 8px !important;
}
.v-text-field .v-input__append-inner,
.v-text-field .v-input__prepend-inner {
  margin-top: 6px;
  margin-right: 6px;
  font-size: 22px;
}

.v-input__append-outer {
  margin-right: -32px;
}

.v-input__append-outer i {
  margin-top: 7px;
  font-weight: 700;
  font-size: 26px;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: rgba(0, 0, 0, 0.2);
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: rgba(0, 0, 0, 0.2);
}

.v-text-field.v-input--has-state > .v-input__control > .v-input__slot:before {
  border-color: currentColor;
}

.theme--light.v-icon {
  color: rgba(0, 0, 0, 0.3) !important;
}

.v-messages__message {
  text-align: right;
  font-style: italic;
}

.error--text .v-messages__message {
  color: #d32f27;
}

/* Vuetify Switch */
.bxp-switch .v-input__slot {
  height: 14px !important;
}
.bxp-switch .v-input__prepend-outer {
  margin-right: 16px !important;
}
.bxp-switch .v-input__append-outer {
  margin-left: 0;
}
.bxp-switch.center {
  justify-content: center !important;
}
.bxp-switch p {
  color: rgba(0,0,0,0.87) !important;
  font-size: 14px;
  font-weight: 400;
}

.bxp-footer {
  background: none !important;
}

@media (max-width: 1032px) {
  .bxp-switch .v-input__append-outer,
  .bxp-switch .v-input__prepend-outer {
    font-size: 12px;
  }
  .bxp-switch .v-input__prepend-outer {
    margin-right: 12px !important;
  }
  .bxp-switch .v-input__append-outer {
    margin-left: -4px !important;
  }
}
/* END Vuetify Switch */


/* Vuetify Checkbox */
.v-input--checkbox .v-input--selection-controls__input .v-icon {
  font-size: 17px !important;
}
.v-input--checkbox .v-input--selection-controls__ripple {
  /* left: -17px !important; */
}

.v-input .v-messages__message {
  margin-right: 3px !important;
}

/* Transitions */
.pop-in-enter,
.pop-in-leave-to {
  opacity: 0;
  transform: scale3d(0, 0, 0) !important;
}
.pop-in-leave,
.pop-in-enter-to {
  opacity: 1;
  transform: scale3d(1, 1, 1) !important;
}
.pop-in-enter-active,
.pop-in-leave-active {
  transition: all 250ms;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
.fade-in-leave,
.fade-in-enter-to {
  opacity: 1;
}
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 250ms;
}

/* Hubspot Overrides */
body {
  padding-top: 0 !important;
}

/* Responsive */

@media (max-width: 1032px) {
  .v-toolbar__content {
    height: 78px !important;
    padding: 0 13px !important;
  }

  .bxp-nav-items-container.close .v-icon {
    margin-right: 18px;
  }
}
</style>
